import { HOME_PATH } from './routes.constant';
import { APP_TITLE } from '@app/core/constants/apis-list.constant';

export const MetaTags = [
  {
    url: HOME_PATH,
    title: APP_TITLE,
    keywords: APP_TITLE,
    description: APP_TITLE,
    author: APP_TITLE,
  },
];
